import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Label, SemanticSIZES } from "semantic-ui-react";
export interface IARStatusIcon extends WithTranslation {
  value: string;
  label?: string;
  size?: SemanticSIZES;
}

class ARStatusIcon extends React.Component<IARStatusIcon> {
  public render() {
    const { label } = this.props;
    return (
      <React.Fragment>
        {this.renderStatus()}
        {label ? ` ${label}` : null}
      </React.Fragment>
    );
  }

  private renderStatus = () => {
    const { value, size, t } = this.props;
    switch (value) {
      case "0":
        return (
          <Label size={size} color={"green"}>
            0
          </Label>
        );
      case "1":
        return (
          <Label size={size} color={"yellow"}>
            1
          </Label>
        );
      case "2":
        return (
          <Label size={size} color={"orange"}>
            2
          </Label>
        );
      case "3":
        return (
          <Label size={size} color={"orange"}>
            3
          </Label>
        );
      case "4":
        return (
          <Label size={size} color={"orange"}>
            4
          </Label>
        );
      case "5":
        return (
          <Label size={size} color={"red"}>
            5
          </Label>
        );
      case "6":
        return (
          <Label size={size} color={"red"}>
            6
          </Label>
        );
      case "7":
        return (
          <Label size={size} color={"red"}>
            7
          </Label>
        );
      case "8":
        return (
          <Label size={size} color={"brown"}>
            8
          </Label>
        );
      case "9":
        return (
          <Label size={size} color={"brown"}>
            9
          </Label>
        );
        case "10":
          return (
            <Label size={size} color={"yellow"}>
              10
            </Label>
          );
        case "11":
          return (
            <Label size={size} color={"yellow"}>
              11
            </Label>
          );
        case "12":
          return (
            <Label size={size} color={"orange"}>
              12
            </Label>
          );
        case "13":
          return (
            <Label size={size} color={"orange"}>
              13
            </Label>
          );
        case "14":
          return (
            <Label size={size} color={"orange"}>
              14
            </Label>
          );
        case "15":
          return (
            <Label size={size} color={"red"}>
              15
            </Label>
          );
        case "16":
          return (
            <Label size={size} color={"red"}>
              16
            </Label>
          );
        case "17":
          return (
            <Label size={size} color={"red"}>
              17
            </Label>
          );
        case "18":
          return (
            <Label size={size} color={"brown"}>
              18
            </Label>
          );
        case "19":
          return (
            <Label size={size} color={"brown"}>
              19
            </Label>
          );
          case "20":
          return (
            <Label size={size} color={"yellow"}>
              20
            </Label>
          );
        case "21":
          return (
            <Label size={size} color={"yellow"}>
              21
            </Label>
          );
        case "22":
          return (
            <Label size={size} color={"orange"}>
              22
            </Label>
          );
        case "23":
          return (
            <Label size={size} color={"orange"}>
              23
            </Label>
          );
        case "24":
          return (
            <Label size={size} color={"orange"}>
              24
            </Label>
          );
        case "25":
          return (
            <Label size={size} color={"red"}>
              25
            </Label>
          );
        case "26":
          return (
            <Label size={size} color={"red"}>
              26
            </Label>
          );
        case "27":
          return (
            <Label size={size} color={"red"}>
              27
            </Label>
          );
        case "28":
          return (
            <Label size={size} color={"brown"}>
              28
            </Label>
          );
        case "29":
          return (
            <Label size={size} color={"brown"}>
              29
            </Label>
          );
          case "30":
            return (
              <Label size={size} color={"yellow"}>
                30
              </Label>
            );
          case "31":
            return (
              <Label size={size} color={"yellow"}>
                31
              </Label>
            );
          case "32":
            return (
              <Label size={size} color={"orange"}>
                32
              </Label>
            );
          case "33":
            return (
              <Label size={size} color={"orange"}>
                33
              </Label>
            );
          case "34":
            return (
              <Label size={size} color={"orange"}>
                34
              </Label>
            );
          case "35":
            return (
              <Label size={size} color={"red"}>
                35
              </Label>
            );
          case "36":
            return (
              <Label size={size} color={"red"}>
                36
              </Label>
            );
      case "F":
        return (
          <Label size={size} color={"black"}>
            F
          </Label>
        );
      default:
        return t("module.accountReceivable.arStatusIcon.waitingProcess");
    }
  };
}
export default withTranslation()(ARStatusIcon);
